module.exports = __webpack_public_path__ + "media/images/athletes/3595-d1c6e45c6c368587b1a0c2e83f4aceaa.png";